import Vue from 'vue'
import Router from 'vue-router'
import CreateAccount from '@/components/signup/CreateAccount'
import SetupAccount from '@/components/signup/SetupAccount'
import TokenLogin from '@/components/login/TokenLogin'
import RequestAccess from '@/components/user/RequestAccess'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'CreateAccount', component: CreateAccount },
    { path: '/edu', name: 'CreateAccountEdu', component: CreateAccount, props: {
      createTitleText: "create_your_edu_account", createButtonText: "create_account_edu", signupReasonTexts: ["signup_trustpilot_edu_reason1", "signup_trustpilot_edu_reason2","signup_trustpilot_edu_reason3"]
      } },
    { path: '/setupAccount/:id', name: 'SetupAccount', component: SetupAccount },
    { path: '/tokenlogin', name: 'TokenLogin', component: TokenLogin },
    { path: '/requestaccess', name: 'RequestAccess', component: RequestAccess },
    /*{ path: '/', redirect: '/login' },*/
  ]
})



// WEBPACK FOOTER //
// ./src/pages/index/signup/router.js